import React from 'react';
import { AlertTriangle } from 'lucide-react';

const NOTICE_HEADING = 'Maintenance in progress';
const NOTICE_TEXT = 'Payout figures are being recalculated. Your order list stays available.';

interface BillingMaintenanceNoticeProps {
  isVisible: boolean;
}

export const BillingMaintenanceNotice: React.FC<BillingMaintenanceNoticeProps> = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div
      role="status"
      className="flex items-start gap-3 border-l-4 border-amber-500 bg-amber-50 p-5"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
      <div>
        <h2 className="text-base font-semibold text-amber-800">{NOTICE_HEADING}</h2>
        <p className="mt-1 text-sm text-amber-800">{NOTICE_TEXT}</p>
      </div>
    </div>
  );
};
